/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';
import qs from 'qs';
class LabelsAPI extends CacheEnabledApiClient {
  constructor() {
    super('labels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'label';
  }

  getRelatedRecordsCount({ labelIds }) {
    const targetUrl = `${this.url}/related_records_count`;

    return axios.get(targetUrl, {
      params: { label_ids: labelIds },
      paramsSerializer: queryParams =>
        qs.stringify(queryParams, { arrayFormat: 'brackets', encode: false }),
    });
  }
}

export default new LabelsAPI();
